import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';

import appRouter from '@app/router';

let footerHeight: number | null = null;

if (!isMobileLayout()) {
    window.addEventListener('resize', () => {
        footerHeight = null;
    });

    appRouter.beforeEach((_from, _to, next) => {
        footerHeight = null;
        next();
    });
}

export const bottomFixedContentOffset = 32; // ticketsStack height

export function getBottomMargin() {
    if (footerHeight != null) {
        return footerHeight;
    }

    const footer = document.querySelector('footer.footer')!;

    if (footer) {
        footerHeight = footer.getBoundingClientRect().height + 8; // 8px is footer margin
    } else {
        footerHeight = 0;
    }

    return footerHeight;
}
